/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button } from '../../../../../components';
import { useI18n } from '@whizz/react-i18n';
import { GLOBAL_ICONS } from '../../../../../util/vars';
import type { ToggleModalProps } from '../../../../../components/modal/types';
import type { StaffPost } from '@whizz/api-model/src/endpoints/Staff';

const StaffLoginInfoModal = ({ toggle, closeCallback, data }: Props): JSX.Element => {
  const { translate } = useI18n();

  return (
    <div className={'container'}>
      <div className={'mb-lg space-y-6'}>
        <p>{translate('pages.ROSTER_MANAGEMENT.STAFF.LOGIN_INFO_MODAL.CONTENT.LINE_2', { email: data!.email })}</p>
        <ul className={'list-disc list-inside'}>
          <li>{translate('pages.ROSTER_MANAGEMENT.STAFF.LOGIN_INFO_MODAL.CONTENT.USERNAME', { username: data!.username })}</li>
          <li>{translate('pages.ROSTER_MANAGEMENT.STAFF.LOGIN_INFO_MODAL.CONTENT.PASSWORD', { password: data!.password })}</li>
        </ul>
        <p>{translate('pages.ROSTER_MANAGEMENT.STAFF.LOGIN_INFO_MODAL.CONTENT.LINE_3')}</p>
      </div>
      <div className={'flex justify-end'}>
        <Button
          icon={GLOBAL_ICONS.confirm}
          isOutline
          onClick={() => {
            toggle(false);
            closeCallback();
          }}
        >
          {translate('pages.ROSTER_MANAGEMENT.STAFF.LOGIN_INFO_MODAL.BUTTONS.CLOSE')}
        </Button>
      </div>
    </div>
  );
};

export default StaffLoginInfoModal;


export interface Props extends Pick<ToggleModalProps, 'toggle'> {
  data?: StaffPost | null;
  closeCallback(): void;
}
